import { Map } from 'immutable';
/**
 * Post state
 *
 * @export
 * @class PostState
 */
var PostState = /** @class */ (function () {
    function PostState() {
        /**
         * The list of user posts
         *
         * @type {*}
         * @memberof PostState
         */
        this.userPosts = Map({});
        this.filteredPosts = Map({});
        /**
         * If user posts are loaded {true} or not {false}
         *
         * @type {Boolean}
         * @memberof PostState
         */
        this.loaded = false;
        /**
         * Stream data storage
         */
        this.stream = Map({ hasMoreData: true, lastPageRequest: -1, lastPostId: '' });
        /**
         * Profile posts data storage
         */
        this.profile = Map({});
    }
    return PostState;
}());
export { PostState };



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/posts/PostState.ts
// module id = 570
// module chunks = 50